var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property } from 'lit/decorators.js';
import { html } from 'lit';
import { BwElement } from './base/bw-element.js';
let BwRecButton = class BwRecButton extends BwElement {
    constructor() {
        super(...arguments);
        this.recording = false;
        this.disabled = false;
        this.size = 'md';
        this.tooltip = '';
        this._onClick = (e) => {
            if (this.disabled) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }
            this.dispatchEvent(new CustomEvent('bw-rec-click', {
                detail: { recording: this.recording },
                bubbles: true,
                composed: true,
            }));
        };
    }
    render() {
        return html `
      <button
        type="button"
        class="bw-rec-inner"
        aria-label=${this.recording ? 'Stop recording' : 'Record'}
        aria-pressed=${this.recording ? 'true' : 'false'}
        ?disabled=${this.disabled}
        title=${this.tooltip}
        @click=${this._onClick}
      >
        <span class="bw-rec-dot" aria-hidden="true"></span>
      </button>
    `;
    }
};
__decorate([
    property({ type: Boolean, reflect: true })
], BwRecButton.prototype, "recording", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], BwRecButton.prototype, "disabled", void 0);
__decorate([
    property({ type: String, reflect: true })
], BwRecButton.prototype, "size", void 0);
__decorate([
    property({ type: String })
], BwRecButton.prototype, "tooltip", void 0);
BwRecButton = __decorate([
    customElement('bw-rec-button')
], BwRecButton);
export { BwRecButton };
//# sourceMappingURL=bw-rec-button.js.map